<template>
<div class="note-box">
  <div class="note-list" >
    <h2>{{noticeDetail.title}}</h2>
    <span><img src="@/assets/time.png">{{noticeDetail.addTime}}</span>
    <p v-html="noticeDetail.content"></p>
  </div>
</div>
</template>

<script>


import {getNoticeById} from "../../api/noticeinfo/noticeinfo";

export default {
  name: "noticeIndex",
  data() {
    return {
      noticeDetail:    {} }
    },

  created() {
    this.id = this.$route.query.id
    getNoticeById(this.$route.query.id).then(res => {
      if (res.code === 10000){
        this.noticeDetail = res.result
      }
    })

  }

}
</script>

<style scoped>
.note-box{
  min-height:100vh;
  background: #ffffff;
  padding: 0 20px;
}
.note-list{
  background: #FFFFFF;
}
.note-list h2{
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dedede;
  height:55px;
  padding: 0 14px;
  font-size:16px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
  justify-content: center;
}
.note-list span{
  display: flex;
  align-items: center;
  font-size:12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  padding:14px 0 14px 0;
}
.note-list span img{
  display: flex;
  width:12px;
  margin-right: 2px;
}
.note-list p{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height:21px;
  padding: 0 0 14px 0;
}
</style>
